export const inspectTable = [
  {
    content: "관리감독자 지정 및 감시인 배치",
    isChecked: "",
  },
  {
    content: "밀폐공간작업 관계자외 출입금지 표지판 게시",
    isChecked: "",
  },
  {
    content: "밸브차단, 맹판설치, 불활성가스 치환, 용기세정",
    isChecked: "",
  },
  {
    content: "전기회로, 기계장비 가동장치, 유압, 압축공기 잠금 및 시건조치",
    isChecked: "",
  },
  {
    content: "산소 및 유해가스 측정",
    isChecked: "",
  },
  {
    content: "환기시설 설치 및 환기 실시여부",
    isChecked: "",
  },
  {
    content: "전화 및 무선기기 구비",
    isChecked: "",
  },
  {
    content: "방폭형 전기기계기구의 사용",
    isChecked: "",
  },
  {
    content: "소화기 비치",
    isChecked: "",
  },
  {
    content: "공기호흡기 또는 송기마스크 비치",
    isChecked: "",
  },
  {
    content: "필요한 안전장비 구비",
    isChecked: "",
  },
  {
    content: "안전보건교육 실시",
    isChecked: "",
  },
];
